<template>
  <div>
    <span>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            class="rounded-lg mr-2 pa-4"
            color="primary"
            outlined
            v-if="!isCustomer"
            v-bind="attrs"
            v-on="on"
            @click="openAddressLocationDialog = true"
          >
            <v-icon class="mr-2" small>mdi-map-marker-multiple</v-icon>
            <span>location</span>
          </v-btn>
        </template>
        <span class="text-capitalize">View Customer Address Location</span>
      </v-tooltip>
    </span>

    <BaseDialog
      :title="`${customerAddressModule.customerAddress} Locations`"
      v-model="openAddressLocationDialog"
      width="80vw"
      height="80vh"
      cardTextClass="px-0 pb-0"
      @reset="openAddressLocationDialog = false"
    >
      <template #information>
        <div class="background_color pa-4">
          <v-row no-gutters>
            <v-col cols="8" class="pr-4">
              <GoogleMap
                v-if="openAddressLocationDialog"
                :hasMapInfo="true"
                id="addressLocation"
                mapWidth="100%"
                mapHeight="60vh"
                ref="addressLocation"
                :clusterMarkers="true"
              >
                <template #mapInfo>
                  <MapInfo legendType="customer_address_location" />
                </template>
              </GoogleMap>
            </v-col>
            <v-col cols="4">
              <v-card elevation="0" class="pa-4 d-flex">
                <v-row no-gutters>
                  <v-col cols="6" class="d-flex align-center">
                    <h4 class="text-capitalize primary--text">
                      {{ customerAddressModule.customerAddress }}
                    </h4>
                  </v-col>
                  <v-col cols="6" class="d-flex justify-end">
                    <PaginationCount
                      :total="
                        !isCustomer ? totalItems : customerAddressList.length
                      "
                    />
                  </v-col>
                </v-row>
              </v-card>
              <div
                style="height: calc(60vh - 70px); border: 2px solid white"
                class="overflow-y-auto app-dialog-list pa-4"
              >
                <v-row no-gutters v-if="!isCustomer">
                  <v-col
                    cols="4"
                    v-for="(page, index) in totalPages"
                    :key="index"
                    class="pr-2 pb-2"
                  >
                    <v-chip
                      label
                      class="w-100 d-flex justify-center"
                      :class="pageNo == page ? 'primary' : ''"
                      @click="getCustomerAddressPage(page)"
                    >
                      {{ index * itemPerPage + 1 }} -
                      {{ page == totalPages ? totalItems : page * itemPerPage }}
                    </v-chip>
                  </v-col>
                </v-row>
                <div v-else>
                  <div
                    v-for="(customer, index) in customerAddressList"
                    :key="index"
                  >
                    <v-card
                      class="pa-4 my-2 card-box-shadow"
                      :class="customer.id == selectedID ? 'selectColor' : ''"
                      elevation="0"
                      @click="selectCustomer(customer)"
                    >
                      <v-row no-gutters>
                        <v-col
                          cols="3"
                          class="d-flex justify-center algin-center"
                        >
                          <v-icon color="error">
                            mdi-store-marker-outline</v-icon
                          >
                        </v-col>
                        <v-col cols="9">
                          <h4>{{ customer.location_id }}</h4>
                          <h5 class="font-weight-light">
                            {{ customer.address }}
                          </h5>
                        </v-col>
                      </v-row>
                    </v-card>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </template>
    </BaseDialog>
  </div>
</template>

<script>
import { bus } from "@/main";
import BaseDialog from "@/components/BaseComponents/BaseDialog.vue";
import GoogleMap from "@/components/BaseComponents/GoogleMap.vue";
import MapInfo from "@/components/BaseComponents/MapInfo.vue";
import PaginationCount from "@/components/BaseComponents/PaginationCount.vue";
import { customerAddressModule } from "@/utils/moduleMapping";

export default {
  components: { BaseDialog, GoogleMap, MapInfo, PaginationCount },
  props: {
    customerID: {
      type: [String, Number],
    },
  },
  data() {
    return {
      customerAddressModule,
      branchDetails: {},
      customerAddressList: [],
      selectedID: null,
      openAddressLocationDialog: false,
      totalItems: 0,
      itemPerPage: 50,
      pageNo: 1,
    };
  },
  computed: {
    isCustomer() {
      return !!this.customerID;
    },

    selectedBranch() {
      let obj = this.$helper.getUserDetailsLocalStorage();
      if (obj) {
        return obj.preferred_branch.id;
      } else {
        return null;
      }
    },
    customerAddressID() {
      return this.customerAddressList.map((v) => v.id);
    },
    offset() {
      return this.itemPerPage * (this.pageNo - 1);
    },
    totalPages() {
      return Math.ceil(this.totalItems / this.itemPerPage);
    },
  },
  watch: {
    openAddressLocationDialog(val) {
      if (val) {
        this.getBranchObject();
        this.getCustomerAddressList();
      } else {
        this.resetLocation();
      }
    },
  },
  methods: {
    openDialogBox() {
      this.openAddressLocationDialog = true;
    },
    selectCustomer(customerAddress) {
      this.selectedID =
        this.selectedID == customerAddress.id ? null : customerAddress.id;
      if (this.selectedID) {
        this.$refs.addressLocation.removeAllMarkers();
        this.$refs.addressLocation.setDroppingLocation(
          [customerAddress],
          "old_location"
        );
      } else {
        this.selectedID = null;
        this.$refs.addressLocation.removeAllMarkers();
        this.$refs.addressLocation.setDroppingLocation(
          this.customerAddressList,
          "old_location"
        );
      }
    },
    resetLocation() {
      this.branchDetails = {};
      this.customerAddressList = [];
      this.pageNo = 1;
      let timer = setInterval(() => {
        if (this.$refs.addressLocation) {
          clearInterval(timer);
          this.$refs.addressLocation.clearGeoJson();
          this.$refs.addressLocation.removeAllMarkers();
        }
      }, 100);
      setTimeout(() => {
        clearInterval(timer);
      }, 1000);
    },
    setLocations() {
      let inter = setInterval(() => {
        if (
          this.$refs.addressLocation &&
          this.$refs.addressLocation.map &&
          window.google &&
          window.google.maps
        ) {
          clearInterval(inter);
          this.$refs.addressLocation.clearGeoJson();
          this.$refs.addressLocation.removeAllMarkers();

          if (this.branchDetails && this.branchDetails.serviceable_area) {
            this.$refs.addressLocation.addFeatures([
              {
                geometry: this.branchDetails.serviceable_area,
                type: "Feature",
              },
            ]);
          }

          if (this.customerAddressList.length > 0) {
            this.$refs.addressLocation.setDroppingLocation(
              this.customerAddressList,
              "old_location"
            );
          }
        }
      });
      setTimeout(() => {
        clearInterval(inter);
      }, 3000);
    },
    getBranchObject() {
      this.$api.branch
        .getBranchObject(this.selectedBranch)
        .then((res) => {
          this.branchDetails = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCustomerAddressPage(page) {
      this.pageNo = page;
      this.getCustomerAddressList();
    },
    getCustomerAddressList(params = {}) {
      params = {
        ...params,
        offset: this.offset,
        limit: this.itemPerPage,
      };

      if (this.customerID) {
        params.customer = this.customerID;
        params.limit = "all";
      } else {
        delete params.customer;
        params.limit = this.itemPerPage;
      }

      bus.$emit("showLoader", true);
      this.$api.customerAddress
        .getCustomerAddressList(params)
        .then((res) => {
          this.customerAddressList = res.data;
          this.totalItems = res.count;
          this.setLocations();
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
  },
};
</script>

<style lang="scss">
.selectColor {
  border: 1px solid var(--v-primary-lighten1) !important;
}
.app-dialog-list::-webkit-scrollbar {
  width: 10px;
}

.app-dialog-list::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.app-dialog-list::-webkit-scrollbar-thumb {
  background-color: var(--v-primary-base) !important;
}
</style>
